<template>
  <div>
    <div class = "row">
      <div class = "container my_new_container">
        <!--Dashboard Headline-->
        <div class= "dashboard-headline">
          <h1>View Counts</h1>
          <!--BreadCrumbs-->
          <nav id = "breadcrumbs" class = "dark">
            <li><a href= "#">Home</a></li>
            <li>View Counts</li>
          </nav>
        </div>

        <b-tabs class="my_tab_job tab_header_action_th survay_calender">
          <!--This was only done to have a nice header but there are no other tabs-->
          <b-tab :title = "'View Count'" @click ="changeTabViewCount">
            <div class="container new_cnt_pdng my_new_container">
              <div class="row">
                <div class = "big_screen_calendr_font search_common_margin_bottom_28 mobile_tab_max_width_flex select-service-box date-picker-field clearfix col-xl-6  calender_z_index_9 calender_in_mobile new_calender_section">
                  <div>
                    <label class="timesheet_label new_style_label required_sign required desktop_margin_bottom_zero">Date Range</label>
                    <b-form-group id="input-group-6" class="desktop_margin_bottom_zero">
                      <date-range-picker 
                        class="timesheet_calender_new manage_job_date_claneder common_date_range_picker_new transactions_jb_calender common_width_100"
                        ref = "picker"
                        :minDate= "minDate"
                        :opens="center"
                        :locale-data="locale"
                        :auto-apply="auto"
                        :ranges="range"
                        v-model = "dateRangeViewCount"
                        @update="selectOptions()"
                        >
                          <div slot = "input" slot-scope= "picker">
                            {{ picker.startDate | date }} -
                            {{ picker.endDate | date }}
                          </div>
                      </date-range-picker>
                    </b-form-group>
                  </div>
                </div>
                <!--Component name-->
                <div class = "col-xl-4 mobile_tab_max_width_fle search_common_margin_bottom_28">
                  <b-form-group
                    id="input-group-8"
                    class="desktop_margin_bottom_zero"
                  >
                    <b-form-select
                      v-model="component_name"
                      :options="component_name_list"
                      class = "mb-0 common_border_search common_select_focus common_black_multiselect_border job_list_multi_select model_multi_select admin_multi_select date_style_size"
                      @change="selectOptions"
                      placeholder="Component Name">
                    </b-form-select>
                  </b-form-group>
                </div>

                <div class = "col-xl-2  mobile_tab_max_width_flex search_common_margin_bottom_28">
                  <div class="sidebar-widget job_list_btn_search mobile_space_between penalty_btn desktop_margin_bottom_zero food_btn">
                    <b-button 
                      class="btn ml-0 common_export_btn common_z_index_zero button ripple-effect desktop_margin_right_zero btn-secondary"
                      @click = "exportViewCounts()">Export</b-button>
                  </div>
                </div>
              </div>
            </div>

            <!--Table for the View Counts-->
            <div class="row mobile_swap_row screen_row_swap_1000_to_1100">
              <div class="col-xl-6">
                <b-table
                  ref="datatableViewCount"
                    show-empty
                    striped
                    hover
                    responsive
                    :items = "getViewCount"
                    :fields="fieldsVC"
                    :current-page = "currentPage"
                    :per-page = "perPage"
                    :filter="filterFL"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    class="desktop_margin_top_zero new_box_tbl_mrgn mobile_min_width_1000 nine_grid_tbl_new">
                      <!--Date -->
                      <template  #cell(view_date)="items">
                        {{ items.item.view_date | date }}
                      </template>
                      <!--Number of Counts-->
                      <template #cell(view_count) = "items">
                        {{ items.item.view_count }}
                      </template>
                </b-table>
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    @input="getViewCount"
                    align="center"
                    class="mt-3"
                  />
              </div>

              <!--View Count Line Graph-->
              <div class = "col-xl-6">
                <div class = "container my_new_container">
                  <h4><b>View Count Graph</b></h4>
                    <canvas ref="lineChart" class="canvas_view_count"></canvas>
                </div>
              </div>
            </div>

            <!--Pagination-->
            <nav class = "pagination-box custom_pagination_border_radius survay_mobile_box_shadow">
                  <div class="page-row-box d-inline-block">
                    <b-form-group id="input-group-4">
                    <span class = "d-inline-block">Row per page</span>
                    <span class = "d-inline-block">
                      <b-form-select
                        v-model = "form.rowsPerPage">
                        <option>25</option>
                        <option>50</option>
                        <option>75</option>
                        <option>100</option>
                      </b-form-select>
                    </span>
                  </b-form-group>
                </div>
              </nav>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>


<script>
import { POST_API } from "../../../../store/actions.type";
import moment from "moment";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import Chart from 'chart.js';
import permission from "../../../../../../server/permission.js";

export default{
  data(){
    return{
      //ViewCountItems:[],
      component_result: [],
      lineChartInstance: null,
      chartDataArr: {},
      total_views: 0,
      itemsGraph:[],
      totalViewsArr :[],
      allDatesArr:[],
      sortBy: null,
      sortDirection: "desc",
      currentPage: 1, 
      totalRows: 0,
      perPage: 25,
      sortDesc: true,
      minDate: null,
      component_name: "map_view",
      range: false,
      currentTab: "viewCount",
      auto: true,
      filter: "",
      webServerUrl: process.env.VUE_APP_SERVER_URL,
      //assigning this right now to test functionality, will pass it dynamically later
      // component_name_list: [
      //   { value: "map_view", text: "Map View" },
      //   { value: "list_view", text: "List View" },
      //   { value: "detail_view", text: "Detail View" },
      // ],

      component_name_list: [],
      fieldsVC: [
        { key: "view_date", label: "View Date", sortable: true},
        { key: "view_count", label: "View Count", sortable: false },
      ],
      form: {
        rowsPerPage: 25,
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              min: 0,
              max: 500,
              stepSize: 50,
              precision: 0
            }
          }]
        },
        legend: {
          display: true,
          position: 'top'
        }
      },
      dateRangeViewCount: {
        startDate: "",
        endDate: "",
      },
      dateRangeViewCount: {
        startDate: moment().subtract(7, "days").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      locale: {
        direction: "ltr", //direction of text
        format: "DD-MMM-YYYY", //fomart of the dates displayed
        separator: " - ", //separator between the two ranges
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        /*weekLabel: 'W',
                customRangeLabel: 'Custom Range',*/
        daysOfWeek: moment.weekdaysMin(), //array of days - see moment documenations for details
        monthNames: moment.monthsShort(), //array of month names - see moment documenations for details
        firstDay: 0, //ISO first day of week - see moment documenations for details
        sameDateFormat: {
          from: "DD MM YYYY, hh:mm",
          to: "hh:mm",
        },
      },
    };
  },
  filters: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    customFormatterOne(date) {
      return moment(date).utc().format("DD MMM YYYY hh:mm A");
    },

    removeUnderscore: function (value) {
      if (!value) return "";
      var i,
        frags = value.split("_");
      for (i = 0; i < frags.length; i++) {
        frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
      }
      return frags.join(" ");
    },
    date: function (date) {
      if (date) {
        return moment(date).format("DD/MM/YYYY");
      } else {
        return "-";
      }
    },
  },
  components: {
    DateRangePicker,
  },
  methods: {
    selectOptions(){
      this.$refs.datatableViewCount.refresh();
      this.getViewCount();
    },
    exportViewCounts(){
      var base_url = this.webServerUrl;
      var page = this.currentPage;
      var rowsPerPage = this.form.rowsPerPage;
      var start_date = this.dateRangeViewCount.startDate
        ? moment(this.dateRangeViewCount.startDate).format("YYYY-MM-DD")
        : "";
      var end_date = this.dateRangeViewCount.endDate
        ? moment(this.dateRangeViewCount.endDate).format("YYYY-MM-DD")
        : "";
      var sortBy = this.sortBy ? this.sortBy : "view_date";
      var sortDirection = this.sortDesc ? "desc" : "asc";
      var export_url =
        "/api/tableViewCount-excel/" +
        page +
        "/" +
        rowsPerPage +
        "/" +
        start_date +
        "/" +
        end_date +
        "/" +
        sortBy +
        "/" +
        sortDirection +
        "/" +
        this.component_name;

      window.open(base_url + export_url, "_blank");
    },
    //If there is a different tab to be created can use this code
    // changeTabViewCount() {
    //   this.currentTab = "viewCount";
    //   this.$refs.datatableViewCount.refresh();
    // },
    getComponentNames(){
      this.$store.dispatch(POST_API, {
        data: {},
        api: "/api/ViewComponentNames"
      })
      .then(() => {
        this.component_result = this.$store.getters.getResults.data;
        if (this.component_result && this.component_result.length){
          this.component_name_list = this.component_result;
          if(!this.component_name){
            this.component_name = component_result[0].value;
          }
        }
      })
      .catch(err => {
      console.error("Component name fetch failed:", err);
      });
    },
    getViewCount(){
      //console.log("getViewCount() called");
      return this.$store
        .dispatch(POST_API, {
          data: {
            page: this.currentPage,
            keyword: this.filter, 
            type: this.currentTab,
            rowsPerPage: this.form.rowsPerPage,
            component_name: this.component_name,
            start_date: this.dateRangeViewCount.startDate
              ? moment(this.dateRangeViewCount.startDate).format("YYYY-MM-DD")
              : "",
            end_date: this.dateRangeViewCount.endDate
              ? moment(this.dateRangeViewCount.endDate).format("YYYY-MM-DD")
              : "",
            sortBy: this.sortBy ? this.sortBy : "view_date",
            sortDirection: this.sortDesc ? "desc" : "asc",
          },
          api: "/api/ViewCount",
        })
        .then(() => {
          if(this.$store.getters.containsErrors) {
            this.error_message = this.$store.getters.getErrors;
            return [];
          }else {
            this.items = this.$store.getters.getResults.pageOfItems;
            this.totalRows = this.$store.getters.getResults.pager.totalItems;
            this.perPage = this.$store.getters.getResults.pager.pageSize;
            this.from = this.$store.getters.getResults.pager.from;
            this.to = this.$store.getters.getResults.pager.to;

            this.updateGraph(this.items); //update chart with table rows
            return this.items;
          }
      })
    },
    
    // getTotalGraph(){

    //   const formattedStart = this.dateRangeViewCount.startDate
    //     ? moment(this.dateRangeViewCount.startDate).format("YYYY-MM-DD")
    //     : "";

    //   const formattedEnd = this.dateRangeViewCount.endDate
    //     ? moment(this.dateRangeViewCount.endDate).format("YYYY-MM-DD")
    //     : "";
    //   console.log("Graph API Dates:", formattedStart, formattedEnd);
    //   return this.$store
    //   .dispatch(POST_API, {
    //       data: {
    //         page: this.currentPage,
    //         keyword: this.filter, 
    //         type: this.currentTab,
    //         rowsPerPage: this.form.rowsPerPage,
    //         component_name: this.component_name,
    //         start_date: formattedStart,
    //         end_date: formattedEnd,
    //         sortBy: "view_date",
    //         sortDirection:"asc",
    //         sortDesc: false,
    //       },
    //       api: "/api/ViewCount",
    //   })
    //   .then(() => {
    //     //the case where there is an error
    //     if (this.$store.getters.containsErrors) {
    //       this.error_message = this.$store.getters.getErrors;
    //       return [];
    //     }else{
    //       this.itemsGraph = this.$store.getters.getResults.pageOfItems ;
    //       let allDatesArr = [];
    //     	let totalViewsArr = [];
    //       if (this.itemsGraph.length > 0) {
    //         this.itemsGraph.forEach(entry => {
    //           //console.log("Graph Entry:", entry);
    //           allDatesArr.push(entry.view_date);
    //           totalViewsArr.push(Number(entry.view_count) || 0);
    //         });

    //         const totalViews = totalViewsArr.reduce((acc, val) => acc + parseInt(val), 0);
    //         this.total_views = totalViews > 0 ? totalViews : 0;

    //         this.allDatesArr = allDatesArr;
    //         this.totalViewsArr = totalViewsArr;
    //         this.chartDataArr = {
    //           labels: this.allDatesArr,
    //           datasets: [{
    //             label: 'Total Views',
    //             backgroundColor: 'rgba(255, 255, 255, 0.2)',
    //             borderColor: 'rgba(75, 192, 192, 1)',
    //             borderWidth: 2,
    //             data: this.totalViewsArr
    //           }]
    //         };

    //         const ctx = this.$refs.lineChart.getContext("2d");

    //         if (this.lineChartInstance) {
    //           this.lineChartInstance.destroy();
    //         }

    //         this.lineChartInstance = new Chart(ctx, {
    //           type: "line",
    //           data: this.chartDataArr,
    //           options: this.chartOptions,
    //           elements: {
    //             line: {
    //               tension: 0
    //             }
    //           }
    //         });
    //       }else{
    //         // No data fallback
    //         this.totalViewsArr = [];
    //         this.allDatesArr = [];

    //         this.chartDataArr = {
    //           labels: [],
    //           datasets: [{
    //             label: 'Total Views',
    //             backgroundColor: 'rgba(255, 255, 255, 0.2)',
    //             borderColor: 'rgba(75, 192, 192, 1)',
    //             borderWidth: 2,
    //             data: []
    //           }]
    //         };

    //         const ctx = this.$refs.lineChart.getContext("2d");
    //         if (this.lineChartInstance) {
    //           this.lineChartInstance.destroy();
    //         }
    //         this.lineChartInstance = new Chart(ctx, {
    //           type: 'line',
    //           data: this.chartDataArr,
    //           options: this.chartOptions,
    //           elements: {
    //             line: {
    //               tension: 0
    //             }
    //           }
    //         });
    //       }
    //     }

    //   })
    // }
    updateGraph(items) {
      const allDatesArr = [];
      const totalViewsArr = [];

      const reversedItems = [...items].reverse();

      reversedItems.forEach(entry => {
        allDatesArr.push(moment(entry.view_date).format("DD/MM/YYYY"));
        totalViewsArr.push(Number(entry.view_count) || 0);
      });

      this.total_views = totalViewsArr.reduce((acc, val) => acc + val, 0);
      this.allDatesArr = allDatesArr;
      this.totalViewsArr = totalViewsArr;

      this.chartDataArr = {
        labels: this.allDatesArr,
        datasets: [{
          label: 'Total Views',
          backgroundColor: 'rgba(255, 255, 255, 0.2)',
          borderColor: 'rgba(75, 192, 192, 1)',
          borderWidth: 2,
          data: this.totalViewsArr
        }]
      };

      const ctx = this.$refs.lineChart.getContext("2d");

      if (this.lineChartInstance) {
        this.lineChartInstance.destroy();
      }

      this.lineChartInstance = new Chart(ctx, {
        type: "line",
        data: this.chartDataArr,
        options: this.chartOptions,
        elements: {
          line: {
            tension: 0
          }
        }
      });
    },
    permissionStaff() {
      if (this.$store.getters.getCurrentUserPermission) {
        if (
          this.$store.getters.getCurrentUserPermission.data.length > 0 &&
          this.$store.getters.currentUser.user_type_id == 2
        ) {
          var menu = this.$store.getters.getCurrentUserPermission.data;
          this.actions = permission.getPermissionStaff(menu, "User Badges");
          this.actionsFreelancer = permission.getPermissionStaff(menu, "Jobseekers");
        }
      }
    },
  },
  mounted(){
    this.getComponentNames();
    this.getViewCount();
    this.permissionStaff();
  },
  watch: {
    currentPage() {
      this.getViewCount();
    },
    'form.rowsPerPage'(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentPage = 1;
        this.getViewCount();
      }
    }
  }
};
</script>